import { Base } from "@/atoms-react/text/Text.react";
import { OlkyPassProLinkType } from "@/features/company/types";
import { useTranslation } from "react-i18next";

type RepresentativeTableHeaderProps = {
  type: OlkyPassProLinkType;
  enableActions: boolean;
};

export const RepresentativeTableHeader = (props: RepresentativeTableHeaderProps) => {
  const { type, enableActions } = props;
  const { t } = useTranslation(["pass"]);

  const textClassName = "text-sm lg:text-base xl:text-xl w-full";

  return (
    <div className="flex min-w-sm flex-row justify-between px-5 lg:min-w-0">
      {enableActions && (
        <div className="flex min-w-[100px] items-center">
          <Base className={textClassName}>{t("business_links.add_link.table_header.0")}</Base>
        </div>
      )}
      <div className="flex min-w-[200px] basis-4/12 items-center">
        <Base className={textClassName}>
          {type === OlkyPassProLinkType.AGENT
            ? t("business_links.add_link.table_header.1")
            : t("business_links.add_link.table_header.1.5")}
        </Base>
      </div>
      <div className="flex min-w-[100px] basis-2/12 items-center">
        <Base className={textClassName}>{t("business_links.add_link.table_header.2")}</Base>
      </div>
      <div className="flex min-w-[100px] basis-2/12 items-center">
        <Base className={textClassName}>{t("business_links.add_link.table_header.3")}</Base>
      </div>
      <div className="flex min-w-[100px] basis-2/12 items-center text-center">
        <Base className={textClassName}>{t("business_links.add_link.table_header.4")}</Base>
      </div>
      <div className="flex min-w-[100px] basis-2/12 items-center text-center">
        <Base className={textClassName}>{t("business_links.add_link.table_header.5")}</Base>
      </div>
      <div className="flex min-w-[100px] basis-2/12 items-center text-center">
        <Base className={textClassName}>{t("business_links.add_link.table_header.6")}</Base>
      </div>
      <div className="min-w-[100px] basis-2/12">
        <Base className={textClassName}></Base>
      </div>
    </div>
  );
};
